import queryString from 'query-string';
import { useCmsData } from '.';
import { useRouter } from 'next/router';
import { TabItemType } from '@/molecules/Tabs/TabItem/types';

type Props = {
  tabsName: string;
};

const useGetCmsToggle = ({ tabsName }: Props): TabItemType<string>[] => {
  const {
    query: { slug, ...query },
    asPath,
  } = useRouter();
  const {
    acf: { queryParameters },
  } = useCmsData();
  const currentUrl = asPath.split('?')[0];
  const choices = queryParameters?.find((q) => q.name === tabsName)?.choices;
  if (!choices) {
    return [];
  }

  const [emptyParam, valueParam] = choices.sort(
    ({ value: valueA }, { value: valueB }) => valueA.length - valueB.length,
  );

  const [toggledKey, toggledValue] = valueParam.value.split('=');
  const { [toggledKey]: removed, ...queryNotToggled } = query;

  const withParamHref = queryString.stringifyUrl(
    { url: currentUrl, query: { ...query, [toggledKey]: toggledValue } },
    { encode: false },
  );
  const withOutParamHref = queryString.stringifyUrl({ url: currentUrl, query: queryNotToggled }, { encode: false });

  return [
    { href: withParamHref, label: valueParam.label, value: valueParam.label, isActive: !!query[toggledKey] },
    { href: withOutParamHref, label: emptyParam.label, value: emptyParam.label, isActive: !query[toggledKey] },
  ];
};

export default useGetCmsToggle;
